import { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Label } from '@/shared/components/ui/label'
import { Input } from '@/shared/components/ui/input'
import { Button } from '@/shared/components/ui/button'
import { Logo } from '@/shared/components/Logo'
import { useSignup } from '../hooks/useSignup'
import { tokenStorage } from '@/lib/auth/tokenStorage'
import type { AccountSignupInput } from '@/shared/types'

export function SignupPage() {
  const [formData, setFormData] = useState<AccountSignupInput>({
    name: '',
    phone: '',
    role: 'VENDOR_OWNER',
  })
  const [logoHref, setLogoHref] = useState('/')
  const navigate = useNavigate()

  useEffect(() => {
    const token = tokenStorage.getToken()
    const vendorId = tokenStorage.getVendorId()
    if (token && vendorId) {
      setLogoHref(`/dashboard/${vendorId}`)
    }
  }, [])

  const handleSuccess = () => {
    navigate(`/verify-otp/${formData.phone}`)
  }

  const { signup, loading } = useSignup({ onSuccess: handleSuccess })

  const handleChange = (key: keyof AccountSignupInput, value: string) => {
    setFormData((prev) => ({ ...prev, [key]: value }))
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-8">
      <div className="max-w-md w-full mx-4">
        <div className="bg-white rounded-lg p-8 shadow-sm">
          <div className="text-center mb-8">
            <div className="w-full flex justify-center items-center mb-4">
              <Logo href={logoHref} />
            </div>
            <h1 className="text-2xl font-bold text-black">Create Your Vendor Account</h1>
            <p className="text-gray-600 mt-2">
              Enter your name and phone number <br /> to get started
            </p>
          </div>

          <form
            onSubmit={(e) => {
              e.preventDefault()
              signup(formData)
            }}
            className="space-y-6"
          >
            <div className="flex flex-col justify-center items-start gap-2">
              <Label>Owner Name</Label>
              <Input value={formData.name} onChange={(e) => handleChange('name', e.target.value)} required />
            </div>
            <div className="flex flex-col justify-center items-start gap-2">
              <Label>Owner Phone Number (10 digits)</Label>
              <Input
                value={formData.phone}
                onChange={(e) => handleChange('phone', e.target.value)}
                maxLength={10}
                required
              />
            </div>

            <Button disabled={loading} type="submit" className="w-full bg-green-600 text-white cursor-pointer">
              {loading ? 'Processing...' : 'Sign up'}
            </Button>

            <div className="text-center">
              <span className="text-gray-600">Already have an account? </span>
              <Link to={loading ? '' : '/login'} className="text-[#2C9C46] hover:underline">
                Login here
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}
